import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import theme from '../../muiTheme';
import UserAvatar from '../UserAvatar/UserAvatar';

const SuggestedAccounts = ({limit, follow,containerSx, profileSx, imageSx, nameSx}) => {

    const [accounts, setAccounts] = useState([]);
    const {suggestedUsers} = useSelector((state)=>state.profileReducer);

    useEffect(()=>{
        //this is where you dispatch get accounts etc
        console.log('SUGGESTED USERS: ', suggestedUsers);

        //filter based on prop
        let filteredAccounts = suggestedUsers || accounts;

        if(limit && suggestedUsers){
            filteredAccounts = suggestedUsers.filter((account, index)=>( index < limit));
        }
        
        setAccounts(filteredAccounts);
    },[suggestedUsers]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                ...containerSx,
            }}
        >

            {accounts?.map((account, index) => {

                let output = (
                    <Box 
                        key={account.name+index}
                        sx={{
                            margin: '10px',
                            background: theme.palette.faint,
                            borderRadius: '15px',
                            padding: '20px',
                            transition: '0.3s',
                            '&:hover': {
                                background: theme.palette.lightGray,
                            },
                            ...profileSx
                        }}
                    >

                        <UserAvatar url={`/profile/${account._id}`} imageURL={account.profileImage} name={account.name} bio={account.bio} follow={follow} verified={account.verified} imageSx={imageSx} nameSx={nameSx}/>

                        

                    </Box>
                );

                return output;
            })}

        </Box>
    );

}

export default SuggestedAccounts; 